import * as React from 'react';

export const EditPencilIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.6324 5.91239L14.0981 4.37811C13.9779 4.25734 13.8349 4.16151 13.6775 4.09612C13.5202 4.03073 13.3514 3.99707 13.181 3.99707C13.0105 3.99707 12.8418 4.03073 12.6844 4.09612C12.527 4.16151 12.3841 4.25734 12.2638 4.37811L5.20954 11.4324C5.15916 11.485 5.12367 11.5501 5.10669 11.621L4.00954 15.4524C3.98806 15.5259 3.98708 15.6039 4.00672 15.6779C4.02636 15.752 4.06587 15.8192 4.12097 15.8724C4.16115 15.9158 4.2104 15.9498 4.26521 15.972C4.32002 15.9942 4.37905 16.0041 4.43811 16.001H4.54954L8.38954 14.921C8.46122 14.9062 8.52686 14.8704 8.57811 14.8181L15.6324 7.76382C15.8767 7.51451 16.0123 7.17858 16.0095 6.82954C16.0105 6.65931 15.9777 6.49058 15.913 6.33314C15.8482 6.1757 15.7528 6.03269 15.6324 5.91239Z"
      fill="currentColor"
    />
  </svg>
);

EditPencilIcon.displayName = 'EditPencilIcon';
